import * as AActions from 'ApplicationEntry/ducks/ProductsRiders/accident';
import * as A from 'ApplicationEntry/models/ProductsRiders/Accident/NewYorkAccident';
import * as ErrorMessages from '../../ErrorMessages';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import './../ProductRiders.sass';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import FixedCodeRiderInformation from '../FixedCodeRiderInformation';

type AccidentProps = {
  accident: A.NewYorkAccident;
};

const Accident = (props: AccidentProps) => {
  const dispatch = useDispatch();
  const {
    planType,
    plan,
    calculatedPremium,
    riderInformation,
    cwa,
    section125,
    baseUnits,
    monthlySalary,
  } = props.accident;
  const [planTypeBlurred, setBlurPlanType] = useState(false);
  const showPlanTypeError = planTypeBlurred && planType.key === 'Empty';
  const [planTypeLabel, setPlanTypeLabel] = useState<HTMLLabelElement | null>();
  const [typeBlurred, setBlurType] = useState(false);
  const [typeLabel, setTypeLabel] = useState<HTMLLabelElement | null>();
  const showPlanError = typeBlurred && plan.key === 'Empty';

  return (
    <>
      <div className="product-riders-section__policy-type" id="accident-section">
        <form noValidate autoComplete="off" className="product-riders-section__policy-type__form">
          <div className="product-riders-section__policy-type__form__row">
            <Grid container spacing={4}>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={showPlanError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setTypeLabel} id="accident-product-type-label">
                    Plan
                  </InputLabel>
                  <Select
                    labelId="accident-label--product-type"
                    labelWidth={typeLabel?.clientWidth}
                    id="accident-product-type"
                    value={plan.key === 'Empty' ? '' : plan.value}
                    onBlur={() => setBlurType(true)}
                    onChange={event => dispatch(AActions.changePlan(event.target.value as string))}
                    displayEmpty
                  >
                    {A.plans.map(plan => (
                      <MenuItem value={plan} key={plan}>
                        {plan}
                      </MenuItem>
                    ))}
                  </Select>
                  {showPlanError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl
                  error={showPlanTypeError}
                  variant="outlined"
                  className="product-riders-section__policy-type__form__row--field"
                >
                  <InputLabel ref={setPlanTypeLabel} id="accident-plantype-label">
                    Plan Type
                  </InputLabel>
                  <Select
                    labelId="accident-label-plantype"
                    labelWidth={planTypeLabel?.clientWidth}
                    id="critical-illness-plantype"
                    value={planType.key === 'Empty' ? '' : planType.value}
                    onBlur={() => setBlurPlanType(true)}
                    onChange={event => {
                      dispatch(AActions.changePlanType(event.target.value as string));
                    }}
                  >
                    <MenuItem value="IND">Individual</MenuItem>
                    <MenuItem value="FAMILY">Family</MenuItem>
                    <MenuItem value="INDSPS">Ind+Sp</MenuItem>
                    <MenuItem value="INDCH">Ind+Ch</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="checkedB"
                      color="secondary"
                      id="accident-section125"
                      checked={section125}
                      onChange={() => dispatch(AActions.changeSection125(!section125))}
                    />
                  }
                  label={<Typography>Section 125</Typography>}
                  className="product-riders-section__policy-type__form__row--field"
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="accident-premium"
                  label="Premium"
                  variant="outlined"
                  placeholder="Enter Premium"
                  margin="normal"
                  fullWidth
                  className="product-riders-section__policy-type__form__row--field"
                  value={calculatedPremium.value}
                  required={section125}
                  onChange={event => {
                    dispatch(AActions.changePremium(event.target.value as string));
                    dispatch(AActions.changeCalculatedPremium(event.target.value as string));
                  }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="accident-cwa"
                  label="CWA"
                  variant="outlined"
                  placeholder="Enter CWA"
                  margin="normal"
                  fullWidth
                  className="product-riders-section__policy-type__form__row--field"
                  value={cwa.value}
                  onChange={event => dispatch(AActions.changeCWA(event.target.value as string))}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  id="accident-monthly-salary"
                  label="Monthly Salary"
                  variant="outlined"
                  placeholder="Enter Monthly Salary"
                  margin="normal"
                  fullWidth
                  className="product-riders-section__policy-type__form__row--field"
                  value={monthlySalary.value}
                  onChange={event => dispatch(AActions.changeMonthlySalary(event.target.value as string))}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControl variant="outlined" className="product-riders-section__policy-type__form__row--field">
                  <InputLabel ref={setTypeLabel} id="accident-type-label">
                    Base Units
                  </InputLabel>
                  <Select
                    labelId="accident-label-type"
                    labelWidth={typeLabel?.clientWidth}
                    id="accident-type"
                    value={baseUnits.key === 'Empty' ? '' : baseUnits.value}
                    onBlur={() => setBlurType(true)}
                    onChange={event => dispatch(AActions.changeBaseUnits(event.target.value as string))}
                    displayEmpty
                  >
                    {A.baseUnits.map(baseUnit => (
                      <MenuItem value={baseUnit} key={baseUnit}>
                        {baseUnit}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            
            <FixedCodeRiderInformation
              riderInformation={riderInformation}
              changeRiderInformationAction={AActions.changeRiderInformation}
              isDisabled={(code: string) => {
                switch (plan.value) {
                  case 'AP4':
                    return false;
                  case 'AP5':
                    switch (code) {
                      case 'APD':
                        return true;
                      default:
                        return false;
                    }
                  default:
                    return true;
                }
              }}
              identifier={'new-york-accident'}
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default Accident;
